import { Router } from '@angular/router';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { getCount } from '@core/_utils/tools.utils';
import { VersionListComponent } from '@documalis/versionlist';

@Component({
    selector: 'documentdetailgrid',
    templateUrl: 'documentdetailgrid.component.html',
    styleUrls: ['documentdetailgrid.component.scss'],
})
export class DocumentDetailComponentGrid implements OnInit {
    @ViewChild('versionlist') public versionlist: VersionListComponent;
    
    @Input() public originClick;
    @Input() public tabview;
    @Input() public editMode;
    @Input() public paramDetail;
    @Input() public pathPdf;
    public countVersion: string = '';
   
    
    constructor(private router: Router) {}

    public ngOnInit() {
    }

    public ngOnChanges() {
        if (this.versionlist !== undefined && this.paramDetail.initialize === true) {
            this.versionlist.reset();
            this.versionlist.docId = this.paramDetail.currentDocId;            
        }
    }

    ngOnDestroy() {
    }

    public handleChange($event) {
        this.paramDetail.viewIndex = $event.index;
        this.resetOutlet();
    }

    public resetOutlet() {
        let wUrl = this.router.url;
        if (wUrl.substring(0, 19) === '/page-basket-detail') {
            this.router.navigate(['/page-basket-detail']);
        }
    }

    public readVer(event) {
        this.countVersion = getCount(event());
    }

}
